import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { FormattedMessage } from 'react-intl';

type Props = {
    violations?: string[] | string | false;
};

export const ValidationViolation = ({ violations }: Props) => {
    if (violations && violations.length > 0) {
        const tooltipContent = Array.isArray(violations) ? (
            violations.map((violation, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: ...
                <div key={violation + index}>
                    <FormattedMessage id={violation} />
                </div>
            ))
        ) : (
            <FormattedMessage id={violations} />
        );

        return (
            <SimpleTooltip content={tooltipContent} innerClassName={'bg-danger text-size-12 text-wrap-balance'}>
                <span className='form-control-feedback uikit-icon icon-error-sign pointer-events-all cursor-help' />
            </SimpleTooltip>
        );
    }

    return null;
};
